import request from "../../utils/fetch";

// generate coupon
//export const generateCoupon = (postData) => request.post(`coupons`, postData);
export const generateCoupon = (postData) => request.post(postData.couponType === "single" ? "coupons/single" : "coupons/bulk", postData);

// get coupon bundle
//export const getCouponBundle = ({limit, companyId}) => limit > 0 ? request.get(`coupons/bundles?sort=-createdAt&page=1&limit=${limit}&company=${companyId}`):request.get(`coupons/bundles?sort=-createdAt`);
export const getCouponBundle = ({ limit, companyId }) => {
  const url = `coupons/bundles?sort=-lastModified${companyId ? `&company=${companyId}` : ""}`;
  return limit > 0 ? request.get(`${url}&page=1&limit=${limit}`) : request.get(url);
};

// get coupon by bundle id
export const getCouponByBundle = (bundleID, exported) => {
  return exported === 1
    ? request.get(
        `coupons?sort=-lastModified&bundle=${bundleID.bundleID}&limit=100000000&fields=companyName,cancellationReason,countryCode,startDate,EndDate,couponValue,valueType,isActive,referralCreatedOn,-_id`
      )
    : request.get(`coupons?sort=-lastModified&bundle=${bundleID.bundleID}`);
};

// delete bundle
export const deleteBundle = ({ id }) => request.put(`coupons/bundles/${id}`, { cancellationReason: "Work InProgress" });

// delete coupon
export const deleteCoupon = (data) => request.put(`coupons/${data.id}`, data.postData);

// edit bundle
export const editBundle = ({ id }) => request.get(`coupons?bundle=${id}&limit=1`);

// edit coupon
export const editCoupon = ({ id }) => request.get(`coupons/${id}`);

// update bundle
export const updateBundle = (postData) => request.patch(`coupons/bundles/${postData.bundleId}`, postData);

// update coupon
export const updateCoupon = (postData) => request.patch(`coupons/${postData.couponId}`, postData);

// send coupon email
export const resendEmail = ({ id }) => request.post(`coupons/${id}`);
